import React from 'react';
import HTLogoRed from '../assets/HTLogoRed.svg';

function HoneywellBanner() {
  return (
    <div className="honeywell-banner">
      <img src={HTLogoRed} alt="HT" className="honeywell-logo" />
    </div>
  );
}

export default HoneywellBanner;
